export const BRIDGE_NAMESPACE = "punto-auto";
